import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getOpportunityMSServiceNoteListData } from './mockData'
import type { IOpportunityMSServiceNote } from '~/types/note/models'

export const {
  getNotes: getOpportunityMSServiceNotes,
  postNote: postOpportunityMSServiceNote,
  patchNote: patchOpportunityMSServiceNote,
  deleteNote: deleteOpportunityMSServiceNote,
  handlers,
} = makeNoteAPIs<IOpportunityMSServiceNote>({
  apiPathEntityNamePrefix: 'opportunitymsservice',
  getNoteListDataFn: getOpportunityMSServiceNoteListData,
})
